import React, { Component } from "react";
import {
  reduxForm,
  destroy,
  arrayPush,
  arrayRemove,
  initialize,
  Field,
} from "redux-form";
import { push, replace } from "react-router-redux";
import Input from "../../../../components/form/Input";
import Password from "../../../../components/form/Password";
import Button from "../../../../components/form/Button";
import Select from "../../../../components/form/Select";
import CroMunicipality from "../../components/generalForm/CroMunicipality";
import CroCountry from "../../components/generalForm/CroCountry";
import DatePicker from "../../../../components/form/DateTime";
import Checkbox from "../../../../components/form/Checkbox";
import CroField from "../../components/generalForm/CroField";
import CroSubhead from "../../components/generalForm/CroSubhead";
import CroLabeledCmp from "../../components/generalForm/CroLabeledCmp";
import { styles } from "../../index";
import {
  OfficialsInRequest,
  OfficialsInInitiative,
} from "../../components/grids/OfficialGrid";
import {
  isLogged,
  isPublic,
  isInternal
} from "../../CroUtils";
import { ztotoznitAction } from "../../CroActions";
import { dataInit } from "../../../../components/Grid/localActions";
import { Order } from "../../../../components/Grid/localProvider";
import fetch from "../../../../utils/fetch";
import { isNil, identity } from "lodash";
import { RequestState, RequestStateRaw } from "../../enum";
import * as V from "../../../../utils/formValidation";
import { generateLogin } from "../../CroActions";
import FilesGrid from "../../components/grids/FilesGrid";
import H from "../../helpEnum";
import { noop } from "../../../../utils";
import { setLoading, togglePanel } from "../../../../actions/appActions";
import { getCzechRepublic } from "../../CroActions";
import CroTextAreaPrint from "../../components/generalForm/CroTextAreaPrint";

const FILES_GRID_NAME = "filesLocalGrid";
const FILES_ADMIN_GRID_NAME = "filesAdminLocalGrid";
const OFFICIAL_GRID_NAME = "officialsLocalGrid";

const FORM_NAME = "requestForm";
class RequestForm extends Component {
  state = {
    showLegalPerson: false,
  };

  componentWillMount() {
    const { dispatch, change, breadcrumbs, breadcrumbsItems, isNew } =
      this.props;
    breadcrumbs(breadcrumbsItems);
    if (isNew) {
      // set default country Czech republic
      getCzechRepublic(dispatch).then((result) => {
        change("person.address.country", result);
        change("person.deliveryAddress.country", result);
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.legalPerson !== this.props.legalPerson &&
      this.props.legalPerson
    )
      this.setState({ showLegalPerson: true });
  }

  generateLogin = (data) => async () => {
    const { change, dispatch } = this.props;
    const { username, password } = await generateLogin(
      `${this.props.auth.startUrl}/api/zadosti/prihlasovaci-udaje/generovat`,
      dispatch,
      data,
    );

    change("applicant.username", username);
    change("applicant.plainPassword", password);
  };

  changeLegalpersonSubform = () => {
    const { change, dispatch } = this.props;

    const newState = !this.state.showLegalPerson;
    this.setState({ showLegalPerson: newState });
    newState
      ? getCzechRepublic(dispatch).then((result) => {
          change("legalPerson.address.country", result);
        })
      : change("legalPerson", null);
  };

  onZtotoznit = async ({ person }) => {
    const { change, dispatch } = this.props;
    const checkedPerson = await ztotoznitAction(person, dispatch);
    change("person", checkedPerson);
  };

  disableGen = () => {
    const { firstName, lastName } = this.props.loginData;
    return !firstName || !lastName;
  };

  onRowClick =
    (url) =>
    ({ id }) =>
      this.props.dispatch(push(`${url}/funkcionari/form/${id}`));

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      accept,
      reject,
      submitting,
      disabled,
      auth,
      onFileAdded,
      onRemoveFile,
      aifo,
      officials,
      onOfficialAdd,
      onRemoveOfficial,
      createdByPublic,
      loginData,
      state,
      password,
      username,
      dispatch,
    } = this.props;
    const { attachments, adminFiles, text, rejectText } = this.props;
    const isZtotozneno = !isNil(aifo);

    return (
      <form onSubmit={handleSubmit(onSubmit)} className="cro-form requestForm">
        {this.state.showLegalPerson && (
          <div className="requestForm__section">
            <CroSubhead title="Právnická osoba" />

            <CroField
              className="half"
              title="Název"
              name="legalPerson.name"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="IČO"
              name="legalPerson.identificationNumber"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.isNumeric, V.required]}
            />

            <CroSubhead title="Sídlo" />
            <CroCountry
              className="half"
              title="Stát"
              name="legalPerson.address"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required, V.beforeToday]}
            />
            <CroMunicipality
              className="half compact-input"
              title="Obec"
              name="legalPerson.address"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required, V.beforeToday]}
            />

            <CroField
              className="half"
              title="Ulice"
              name="legalPerson.address.street"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required, V.beforeToday]}
            />
            <CroField
              className="half"
              title="Č.p./Č.o."
              name="legalPerson.address.orientationNumber"
              component={Input}
              disabled={disabled || createdByPublic}
              helpEnum={H.HOUSE_NUMBER.r}
              validate={[V.required]}
            />

            <CroField
              className="half"
              title="PSČ"
              name="legalPerson.address.zip"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />
          </div>
        )}

        <div className="requestForm__section">
          <CroSubhead title="Žadatel" />

          <div className="requestForm__grid requestForm__grid--applicant">
            <label
              className={isLogged(auth) && !isPublic(auth) ? "half" : "full"}
            >
              <span className="title">Je právnická osoba</span>
              <Checkbox
                value={this.state.showLegalPerson}
                onChange={this.changeLegalpersonSubform}
                disabled={disabled || createdByPublic}
                aria-label="Je právnická osoba"
              />
            </label>

            {isLogged(auth) && !isPublic(auth) && (
              <label className="half">
                <span className="title">Ztotožněno</span>
                <Checkbox value={isZtotozneno} disabled aria-label="Ztotožněno" />
                <Field
                  name="person.aifo"
                  type="hidden"
                  component={Input}
                  style={{ display: "none" }}
                />
              </label>
            )}

            <CroField
              className="third"
              title="Jméno"
              name="person.firstName"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="third"
              title="Příjmení"
              name="person.lastName"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required, V.textSpaceDashOnly, V.noSpaceStartEnd]}
            />
            <CroField
              className="third"
              title="Další jména"
              name="person.middleName"
              component={Input}
              disabled={disabled || createdByPublic}
            />
            <CroField
              className="third"
              title="Datum narození"
              name="person.birthDate"
              component={DatePicker}
              noIcon
              disabled={disabled || createdByPublic}
              validate={[V.required, V.beforeToday]}
            />

            {isLogged(auth) &&
              !isPublic(auth) &&
              (state === RequestStateRaw.NEW ||
                state === RequestStateRaw.ACCEPT) && (
                <CroField
                  className="third"
                  title="Přihlašovací jméno"
                  name="applicant.username"
                  component={Input}
                  disabled={true}
                  validate={V.required}
                />
              )}
            {isLogged(auth) &&
              !isPublic(auth) &&
              !(!isNil(username) && isNil(password)) &&
                (state === RequestStateRaw.NEW ||
                 state === RequestStateRaw.ACCEPT) && (
                  <CroField
                    className="third"
                    title="Heslo"
                    name="applicant.plainPassword"
                    component={Password}
                    disabled={true}
                    alwaysShowEye={true}
                  />
              )}
            {isLogged(auth) &&
              !isPublic(auth) &&
              !isNil(username) &&
              isNil(password) && (
                <div
                  className="third"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  Heslo změněno žadatelem.
                </div>
              )}
          </div>
        </div>

        <div className="requestForm__section">
          <CroSubhead title="Trvalý pobyt" />
          <div className="requestForm__grid">
            <CroCountry
              className="third"
              title="Stát"
              name="person.address"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required]}
            />
            <CroMunicipality
              className="third compact-input"
              title="Obec"
              name="person.address"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required]}
            />
            <CroField
              className="third"
              title="Ulice"
              name="person.address.street"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />

            <CroField
              className="third"
              title="Č.p./Č.o."
              name="person.address.orientationNumber"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
              helpEnum={H.HOUSE_NUMBER.r}
            />
            <CroField
              className="third"
              title="PSČ"
              name="person.address.zip"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />
          </div>
        </div>

        <div className="requestForm__section">
          <CroSubhead
            title="Adresa pro doručování"
            helpEnum={H.REQUEST_ADRESS.r}
            tooltipPosition="top-right"
          />
          <div className="requestForm__grid requestForm__grid--delivery">
            <CroField
              className="half"
              title="Datová schránka"
              name="person.databox"
              component={Input}
              disabled={disabled || createdByPublic}
            />
            <CroField
              className="half compact-input"
              title="E-mail"
              name="person.email"
              component={Input}
              disabled={disabled}
              validate={[V.email]}
              hintText="@"
            />

            <CroCountry
              className="half"
              title="Stát"
              name="person.deliveryAddress"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required]}
            />
            <CroMunicipality
              className="half compact-input"
              title="Obec"
              name="person.deliveryAddress"
              disabled={disabled || createdByPublic}
              form={FORM_NAME}
              validate={[V.required]}
            />

            <CroField
              className="half"
              title="Ulice"
              name="person.deliveryAddress.street"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Č.p./Č.o."
              name="person.deliveryAddress.orientationNumber"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
              helpEnum={H.HOUSE_NUMBER.r}
            />

            <CroField
              className="half"
              title="PSČ"
              name="person.deliveryAddress.zip"
              component={Input}
              disabled={disabled || createdByPublic}
              validate={[V.required]}
            />
          </div>
        </div>

        <div className="requestForm__section">
          <CroSubhead
            title="Obsah"
            helpEnum={H.REQUEST_TEXT.r}
            tooltipPosition="top-right"
          />

          <CroField
            className="textarea"
            title="Text (Uveďte např. právní zájem a účel nakládání s osobními údaji ve smyslu zákona č. 101/2000 Sb., o ochraně osobních údajů a o změně některých zákonů, ve znění pozdějších předpisů)"
            name="text"
            component={Input}
            fullWidth
            multiline
            labelStyle={{ height: "100%", paddingTop: "2%" }}
            disabled={disabled || createdByPublic}
            validate={[V.required]}
          />
          <CroTextAreaPrint
            label="Text (Uveďte např. právní zájem a účel nakládání s osobními údaji ve smyslu zákona č. 101/2000 Sb., o ochraně osobních údajů a o změně některých zákonů, ve znění pozdějších předpisů)"
            text={text}
          />
        </div>

        <div className="requestForm__section requestForm__fullWidth">
          <CroLabeledCmp title="Funkcionáři" required>
            <OfficialsInInitiative
              gridName={OFFICIAL_GRID_NAME}
              items={officials}
              adding={!disabled}
              onAdd={onOfficialAdd}
              filtering={false}
              deleting={!disabled}
              onRemove={onRemoveOfficial}
              onRowClick={
                isPublic(auth) ? this.onRowClick("/verejnost-prihlasen") : noop
              }
            />
          </CroLabeledCmp>
        </div>

        <div className="requestForm__section requestForm__fullWidth">
          <CroLabeledCmp title="Přílohy">
            <FilesGrid
              gridName={FILES_GRID_NAME}
              items={attachments}
              adding={!disabled && !createdByPublic}
              deleting={!disabled}
              onFileAdded={onFileAdded("attachments")}
              onRemove={onRemoveFile("attachments")}
              dispatch={dispatch}
            />
          </CroLabeledCmp>
        </div>

        {isInternal(auth) && (
          <div className="requestForm__section requestForm__fullWidth">
            <CroLabeledCmp title="Soubory správce">
              <FilesGrid
                gridName={FILES_ADMIN_GRID_NAME}
                items={adminFiles}
                adding={!disabled}
                deleting={!disabled}
                onFileAdded={onFileAdded("adminFiles")}
                onRemove={onRemoveFile("adminFiles")}
                dispatch={dispatch}
              />
            </CroLabeledCmp>
          </div>
        )}

        {isLogged(auth) && (
          <div className="requestForm__section">
              <div className="requestForm__grid">
                <CroField
                  title="Stav"
                  name="state"
                  component={Select}
                  items={RequestState}
                  fullWidth
                  disabled
                />

              {state === RequestStateRaw.REJECT && (
                <CroField
                  className="textarea"
                  title="Důvod zamítnutí"
                  name="rejectText"
                  component={Input}
                  multiline
                  fullWidth
                  disabled
                  labelStyle={{ minWidth: 125 }}
                />
              )}
              {state === RequestStateRaw.REJECT && (
                <CroTextAreaPrint label="Důvod zamítnutí" text={rejectText} />
              )}
            </div>
          </div>
        )}

        {!disabled && (
          <div className="requestForm__footer no-print">
            <div className="requestForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="requestForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="requestForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label={isInternal(auth) ? "Uložit" : "Odeslat"}
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {isLogged(auth) && state === RequestStateRaw.NEW && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Generovat jméno a heslo"
                    disabled={submitting || disabled || this.disableGen()}
                    onClick={this.generateLogin(loginData)}
                  />
                )}
                {isLogged(auth) && state === RequestStateRaw.NEW && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Schválit"
                    disabled={submitting || disabled}
                    onClick={handleSubmit(accept)}
                  />
                )}
                {isLogged(auth) && state === RequestStateRaw.NEW && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zamítnout"
                    disabled={submitting || disabled}
                    onClick={reject}
                  />
                )}
                {this.props.onShowHistory && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zobrazit historii"
                    onClick={this.props.onShowHistory}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

const ConnectedForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
})(RequestForm);

export default class RequestFormAdding extends Component {
  static defaultProps = {
    postProcess: identity,
  };

  async componentWillMount() {
    const { url, postProcess, dispatch } = this.props;
    if (!isNil(url)) {
      dispatch(setLoading(true, "Načítání dat..."));
      const response = await fetch(url, dispatch);
      const initialValues = await response.json();

      this.props.dispatch(initialize(FORM_NAME, postProcess(initialValues)));
      this.props.dispatch(
        dataInit(OFFICIAL_GRID_NAME, {
          items: initialValues.officials,
          sort: "created",
          order: Order.DESC,
        }),
      );
      dispatch(setLoading());
    }
  }

  componentWillUnmount() {
    this.props.dispatch(destroy(FORM_NAME));
  }

  startAdding = () => {
    const { dispatch, location } = this.props;
    dispatch(push({ pathname: location.pathname, query: { q: "funkcionar" } }));
  };

  stopAdding = () => {
    const { dispatch, location } = this.props;
    dispatch(replace({ pathname: location.pathname }))
  };

  onAddOfficial = (official, event) => {
    if (!event) return;
    const { officials, dispatch } = this.props;
    if (officials.some((o) => o.id === official.id)) {
      dispatch(togglePanel('Funkcionář je již v seznamu žádosti'));
      return;
    }
    dispatch(arrayPush(FORM_NAME, "officials", official));
    this.stopAdding();
  };

  onAddOfficials = (officialIds, addOfficials) => {
    const { officials, dispatch } = this.props;
    addOfficials.forEach((official) => {
      if(!officials.some((o) => o.id === official.id)) {
        dispatch(arrayPush(FORM_NAME, "officials", official));
      }
    });
    this.stopAdding();
  }

  onRemoveOfficial = (ids) => {
    const { officials } = this.props;
    officials
      .map((item, index) => ({ index, id: item.id }))
      .filter((obj) => ids.includes(obj.id))
      .sort((a, b) => b.index - a.index) //descending
      .forEach((obj) =>
        this.props.dispatch(arrayRemove(FORM_NAME, "officials", obj.index)),
      );
  };

  onFileAdded = (field) => (fileRef) => {
    this.props.dispatch(arrayPush(FORM_NAME, field, fileRef));
  };

  onRemoveFile = (field) => (ids) => {
    (this.props[field] || [])
      .map((item, index) => ({ index, id: item.id }))
      .filter((obj) => ids.includes(obj.id))
      .sort((a, b) => b.index - a.index) //descending
      .forEach((obj) =>
        this.props.dispatch(arrayRemove(FORM_NAME, field, obj.index)),
      );
  };

  fillPublicRequestOfficial = async (id) => {
    const { dispatch, location } = this.props;

    dispatch(push({ pathname: location.pathname }));
    const response = await fetch(`/verejnost/api/funkcionari/${id}`, dispatch);
    const official = await response.json();
    dispatch(arrayPush(FORM_NAME, "officials", official));
  };

  render() {
    const {
      auth,
      location: { query },
    } = this.props;

    if (!isNil(query.f)) {
      this.fillPublicRequestOfficial(query.f);
    }
    if (query.q === "funkcionar") {
      return (
        <div>
          <OfficialsInRequest
            url={`${auth.startUrl}/api/funkcionari`}
            onRowClick={(official, event) => this.onAddOfficial(official, event)}
            gridName="officialsGrid_request"
            allowCheck={true}
            moreCheckboxFns={true}
            fnText="Přidat označené"
            onCheckboxFn={this.onAddOfficials}
            deleting={false}
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={this.stopAdding}
          />
        </div>
      );
    }
    return (
      <ConnectedForm
        {...this.props}
        onOfficialAdd={this.startAdding}
        onRemoveOfficial={this.onRemoveOfficial}
        onFileAdded={this.onFileAdded}
        onRemoveFile={this.onRemoveFile}
      />
    );
  }
}
